module.exports = __webpack_public_path__ + "static/media/iconfinder_website_-_address_book_3440827.34bbdd7c.png";